/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_OfflineInputs */

const vi_grower_area_camera_offline = /** @type {(inputs: Grower_Area_Camera_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mất kết nối`)
};

/**

* @param {Grower_Area_Camera_OfflineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_offline = /** @type {((inputs?: Grower_Area_Camera_OfflineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_OfflineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_offline(inputs)
});